import React from "react";
import Result from "./Result";
import PendingResult from "./PendingResult";
import PoolItemWideLoaderLarge from "./PoolItemWideLoaderLarge";
import { useApi } from "../lib/useApi";
import { programKey } from "../lib/program";
import { poolTypeById } from "../poolTypes";

// Only the Pool Types with a Results page (see App.js) render their Results here.
const resultsPoolType = (pool_id) => {
  const poolType = poolTypeById(pool_id);
  return poolType?.slugs.results ? poolType : undefined;
};

const ResultsPage = ({ pool_id }) => {
  const poolType = resultsPoolType(pool_id);

  const renderResultType = (item) => (poolType ? <Result poolType={poolType} item={item} /> : null);

  const renderPendingResultType = (item) =>
    poolType && item.league_title.startsWith(poolType.result.pendingPrefix) ? <PendingResult item={item} /> : null;

  const page_name = poolType ? "Results and Payouts - " + (poolType.result.resultsTitle ?? poolType.name) : "Error ";
  const { data } = useApi(`/api/GetResults/${pool_id}`, {
    select: (json) => {
      const temp = [];
      for (const result of json.value) {
        temp.push(result);
      }
      temp.reverse();
      return { results: temp, page_name };
    },
  });
  const Results = data ? data.results : [];
  const PageName = data ? data.page_name : "";

  const { data: PendingResults = [] } = useApi(`/api/GetPendingResults`, {
    select: (json) => {
      const temp = [];
      for (const pending_result of json.value) {
        temp.push(pending_result);
      }
      return temp;
    },
  });

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        {Results.length > 0 ? (
          <>
            <h1>{PageName}</h1>
            {PendingResults.map((item) => renderPendingResultType(item))}
            {Results.map((item) => <React.Fragment key={programKey(item)}>{renderResultType(item)}</React.Fragment>)}
            <div className="panel">
              Looking for older results?{" "}
              <a href="/archives">
                <b>Visit the Archive</b>
              </a>
            </div>
          </>
        ) : (
          <PoolItemWideLoaderLarge />
        )}
      </div>
    </div>
  );
};

export default ResultsPage;
